import React, { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import moment from 'moment';

import { withTranslation } from 'react-i18next';

// ui
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Input from '@material-ui/core/Input';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import DamChartDaily from './DamChartDaily';
import { damsMediumRid } from '../../../../store/dam';

// export const t = (text) => <Trans>{text}</Trans>;

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const currentYear = moment().year();
const yearsRange = (start, end) => Array.from({
  length: (start - end),
}, (v, k) => (start - k).toString());
const years = yearsRange(currentYear, 2011);

class DamMediumChart extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();

    this.state = {
      selectedType: 'mediumdam_storage',
      selectedYear: [`${currentYear}`, `${currentYear - 1}`, `${currentYear - 2}`],
      selectedDam: '',
      selectedDamSize: 'medium',
      lastUpdated: moment().format('ymdhis'),
    };
  }

  static getDerivedStateFromProps(props, state) {
    // console.log(props.id + '-' + state.selectedDam);
    if (state.selectedDam === '') {
      return {
        selectedDam: props.id,
      };
      // console.log(props.id)
    }

    return null;
  }

  handleChange = (event) => {
    // console.log(event.target);
    if (event.target.name === 'selectedYear') {
      if (event.target.value.length <= 8) {
        this.setState({ [event.target.name]: event.target.value });
      }
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  handleChart = () => {
    // const { selectedType, selectedYear, selectedDam } = this.state;
    // alert(selectedType + ' - ' + selectedYear + ' - ' + selectedDam);

    // this.child.current.renderChart();
    this.setState({ lastUpdated: moment().format('ymdHH:mm:ss') });
  }

  render() {
    const dams = damsMediumRid;
    dams.sort((a, b) => a.name.localeCompare(b.name, 'th'));

    const { t } = this.props;

    const {
      selectedType,
      selectedYear,
      selectedDam,
      selectedDamSize,
      lastUpdated,
    } = this.state;

    return (
      <div>
        <form autoComplete="off">
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm={5} md={5}>
              <FormControl>
                <InputLabel htmlFor="type">{t('ประเภทข้อมูล')}</InputLabel>
                <Select
                  id="type"
                  value={selectedType}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'selectedType',
                    id: 'type',
                  }}
                >
                  <MenuItem value="mediumdam_storage">{t('ปริมาณน้ำเก็บกัก')}</MenuItem>
                  <MenuItem value="mediumdam_inflow">{t('ปริมาณน้ำไหลลง')}</MenuItem>
                  <MenuItem value="mediumdam_released">{t('ปริมาณน้ำระบาย')}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <FormControl>
                <InputLabel htmlFor="year">{t('ปี (สูงสุด 8 ปี)')}</InputLabel>
                <Select
                  id="year"
                  multiple
                  value={selectedYear}
                  onChange={this.handleChange}
                  input={<Input id="year" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                  inputProps={{
                    name: 'selectedYear',
                  }}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      <Checkbox checked={selectedYear.indexOf(year) > -1} />
                      <ListItemText primary={year} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs>
              <FormControl>
                <InputLabel htmlFor="year">อ่างเก็บน้ำ</InputLabel>
                <Select
                  value={selectedDam}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'selectedDam',
                    id: 'dam_id',
                  }}
                >
                  {dams.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} sm={2} md={2}>
              <FormControl>
                <Button id="show_chart" variant="outlined" color="primary" size="small" onClick={this.handleChart}>
                  {t('แสดง')}
                </Button>
              </FormControl>
            </Grid>
          </Grid>
          <Box mb={4} />
        </form>

        <DamChartDaily
          key={lastUpdated}
          // ref={this.child}
          type={selectedType}
          id={selectedDam}
          year={selectedYear}
          size={selectedDamSize}
          name={find(dams, ['id', selectedDam]).name}
        />
      </div>
    );
  }
}

DamMediumChart.propTypes = {
  id: PropTypes.number.isRequired,
};

export default withTranslation()(withStyles(styles)(DamMediumChart));
